import React from 'react';
import { Form } from 'react-bootstrap';
import styles from './oneWayInterviewConfiguration.module.scss';
import { CustomTextField } from '../../../../../../shared/customTextField';
import { CustomButton } from '../../../../../../shared/customButton';
import * as yup from 'yup';
import { Formik } from 'formik';

const OneWayInterviewConfiguration = (props) => {
    //yup validations
    const schema = yup.object({
        interview_name: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').max(60, 'Character length should be less than 60').required('Required'),
    });

    //on submit function
    const onSubmit = async (values) => {
        props.setOneWayInterviewConfiguration(values)
        props.nextPage(2)
    }


    return (
        <div>
            <Formik
                validationSchema={schema}
                onSubmit={(values) => onSubmit(values)}
                initialValues={{ interview_name: props.oneWayInterview.interview_name}}>

                {({
                    values,
                    errors,
                    handleChange,
                    handleSubmit,
                    submitCount
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <div className={styles.editInterviewBox}>
                        <CustomTextField
                            label="Template Name"
                            classLabel="defaultLabel"
                            controlId="interview_name"
                            placeholder="Ex: Software Engineers Template"
                            type="text"
                            value={values.interview_name}
                            name="interview_name"
                            classType="defaultTextBox"
                            handleOnChange={handleChange}
                            maxlength={60}
                            errorMessage={errors.interview_name}
                            isInvalid={submitCount > 0 && !!errors.interview_name}
                        />
                        </div>



                        <hr className={styles.dividerLine} />
                        <div className='d-flex flex-row-reverse'>
                            <div className={styles.navigateBtnCol}>
                                {<CustomButton
                                    id="pipeline_name_confirm"
                                    buttonType="submit"
                                    label="Next"
                                    type="primaryBtn"

                                />}
                            </div>
                        </div>

                    </Form>
                )}
            </Formik>


        </div>
    )
}

export default OneWayInterviewConfiguration;